<div id="personal.my_account" class="container-fluid">

    <div class="row">

        <!-- LEFT COLUMN WITH OPTION LIST -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <action-list [items]="items"
                                 [selected]="selectedItem"
                                 [idPrefix]="idPrefix"
                                 (select)="selectItem($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED ITEM DATA -->

        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content *ngIf="meMyselfAndI">

                    <div [hidden]="selectedItem.id !== MyAccountItems.ADDRESS">
                        <user-address #userAddressComponent
                                      [idPrefix]="idPrefix"
                                      [(bananaBox)]="meMyselfAndI"
                                      [disabled]="disabled">
                        </user-address>
                    </div>

                    <div [hidden]="selectedItem.id !== MyAccountItems.LOGIN">
                        <div class="row no-gutters">
                            <div class="col-md-12 col-lg-6">
                                <user-core #userCoreComponent
                                           [idPrefix]="idPrefix"
                                           [(bananaBox)]="meMyselfAndI"
                                           [disabled]="disabled">
                                </user-core>
                            </div>
                        </div>

                        <mat-card class="mt-3">
                            <mat-card-content>
                                <div class="row no-gutters">
                                    <div class="col-11">
                                        <div class="smp-title-thin-border mb-3">{{ 'login.recover_password.title.change_password' | translate }}</div>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="row no-gutters">
                                            <div class="col-sm-10">

                                                <form [formGroup]="currentPasswordForm" autocomplete="off">

                                                    <mat-form-field class="full-width">
                                                        <mat-label>{{ 'login.recover_password.label.password_old' | translate }}</mat-label>
                                                        <input *ngIf="!showCurrentPassword"
                                                               id="{{idPrefix}}login.input_password.password_current"
                                                               type="password" matInput
                                                               formControlName="passwordCurrent"
                                                               autocomplete="new-password"
                                                               tabindex="0"
                                                               required>
                                                        <input *ngIf="showCurrentPassword"
                                                               id="{{idPrefix}}login.input_text.password_current"
                                                               type="text" matInput
                                                               formControlName="passwordCurrent"
                                                               autocomplete="new-password"
                                                               tabindex="0"
                                                               required>
                                                        <button id="{{idPrefix}}btn.show_password_current"
                                                                type="button"
                                                                mat-button
                                                                matSuffix mat-icon-button
                                                                tabindex="-1"
                                                                (click)="showCurrentPassword = !showCurrentPassword">
                                                            <mat-icon>{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                        </button>
                                                        <mat-error class="mat-error" *ngIf="currentPasswordForm.hasError('required', ['passwordCurrent'])">
                                                            {{ 'login.recover_password.error.required' | translate }}
                                                        </mat-error>
                                                        <mat-error class="mat-error" *ngIf="currentPasswordForm.hasError('password_invalid', ['passwordCurrent'])">
                                                            {{ 'login.recover_password.error.current_password_incorrect' | translate }}
                                                        </mat-error>
                                                    </mat-form-field>

                                                </form>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <dr-password #drPasswordComponent
                                             [idPrefix]="(idPrefix + 'login.')"
                                             (updatePassword)="password = $event">
                                </dr-password>

                                <div class="row no-gutters">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="row no-gutters">
                                            <div class="col-md-10">
                                                <button id="{{idPrefix}}login.btn.change_password"
                                                        mat-flat-button
                                                        color="accent"
                                                        class="full-width"
                                                        (click)="changePassword()"
                                                        [disabled]="!password || currentPasswordForm.hasError('required', ['passwordCurrent'])">
                                                    {{ 'login.recover_password.btn.confirm' | translate | uppercase }}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </mat-card-content>
                        </mat-card>

                    </div>

                    <div [hidden]="selectedItem.id !== MyAccountItems.TWOFA">
                        <div class="row no-gutters">
                            <div class="col-xs-12">
                                <button id="{{idPrefix}}.twoFa.btn.enable"
                                        mat-flat-button
                                        color="accent"
                                        *ngIf="!meMyselfAndI.authentication_method"
                                        (click)="activateTwoFA()"
                                >
                                    {{ 'personal.my_account.2fa.btn.activateTwoFA' | translate | uppercase }}
                                </button>
                                <button id="{{idPrefix}}.twoFa.btn.disable"
                                        mat-flat-button
                                        color="accent"
                                        *ngIf="meMyselfAndI.authentication_method"
                                        (click)="deactivateTwoFA()"
                                >
                                    {{ 'personal.my_account.2fa.btn.deactivateTwoFA' | translate | uppercase }}
                                </button>
                            </div>
                        </div>

                        <div class="row no-gutters mt-1" *ngIf="showAuthenticationMethods || meMyselfAndI.authentication_method">
                            <div class="col">
                                <mat-accordion class="full-width">
                                    <mat-expansion-panel class="mt-2" hideToggle disabled
                                                         *ngFor="let method of availableAuthenticationMethods"
                                                         id="{{idPrefix}}.twoFa.{{method.id}}"
                                                         [expanded]="meMyselfAndI.authentication_method == method.id"
                                    >
                                        <mat-expansion-panel-header (click)="switchTwoFAMethod(method.id)">

                                            <mat-panel-title>
                                                <div class="row full-width align-items-center">
                                                    <div class="col-1" align="middle">
                                                        <mat-radio-group [(ngModel)]="meMyselfAndI.authentication_method" disabled>
                                                            <mat-radio-button id="{{idPrefix}}.twoFa.select_{{method.id}}" [value]="method.id" style="margin-top: 5px;"></mat-radio-button>
                                                        </mat-radio-group>
                                                    </div>

                                                    <div class="col-1 text-right">
                                                        <ng-container *ngIf="meMyselfAndI.authentication_method === method.id">
                                                            <mat-icon class="dr-icon success" *ngIf="meMyselfAndI.isVerified">check_circle</mat-icon>
                                                            <mat-icon class="dr-icon warning" *ngIf="!meMyselfAndI.isVerified">warning</mat-icon>
                                                        </ng-container>
                                                    </div>

                                                    <div class="col-2 pl-0">
                                                        <ng-container *ngIf="meMyselfAndI.authentication_method === method.id">
                                                            <span class="success" *ngIf="meMyselfAndI.isVerified">
                                                                {{ 'personal.my_account.2fa.verified' | translate }}
                                                            </span>
                                                            <span class="warning" *ngIf="!meMyselfAndI.isVerified">
                                                                {{ 'personal.my_account.2fa.not_verified' | translate }}
                                                            </span>
                                                        </ng-container>
                                                    </div>

                                                    <div class="col-8">
                                                        <span>{{ method.displayName | translate }}</span>
                                                    </div>
                                                </div>
                                            </mat-panel-title>

                                        </mat-expansion-panel-header>

                                        <user-2fa-sms *ngIf="method.id === 'SMS'" #user2FASmsComponent
                                            [client]="client"
                                            [(bananaBox)]="meMyselfAndI"
                                            [idPrefix]="idPrefix">
                                        </user-2fa-sms>

                                        <user-2fa-totp *ngIf="method.id === 'TOTP'" #user2FATotpComponent
                                            [client]="client"
                                            [(bananaBox)]="meMyselfAndI"
                                            [idPrefix]="idPrefix">
                                        </user-2fa-totp>

                                    </mat-expansion-panel>
                                </mat-accordion>

                            </div>
                        </div>
                    </div>

                    <div class="row mt-5" [hidden]="selectedItem.id === MyAccountItems.TWOFA">
                        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
                            <button id="{{idPrefix}}btn.save"
                                    mat-flat-button
                                    color="accent"
                                    class="full-width"
                                    [disabled]=""
                                    (click)="save()">
                                {{ 'common.btn.save' | translate | uppercase }}
                            </button>
                        </div>

                        <div class="col-xs-12 col-md-6 col-lg-3" >
                            <a id="{{idPrefix}}btn.cancel"
                               mat-stroked-button
                               color="primary"
                               class="full-width"
                               (click)="cancel()">
                                {{ 'common.btn.cancel' | translate | uppercase }}
                            </a>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>

        </div>

    </div>

</div>
